var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgId(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.5C9.19974 20.5 7.79961 20.5 6.73005 19.955C5.78924 19.4757 5.02433 18.7108 4.54497 17.77C4 16.7004 4 15.3003 4 12.5V12.5C4 9.69974 4 8.29961 4.54497 7.23005C5.02433 6.28924 5.78924 5.52434 6.73005 5.04497C7.79961 4.5 9.19974 4.5 12 4.5V4.5C14.8003 4.5 16.2004 4.5 17.27 5.04497C18.2108 5.52433 18.9757 6.28924 19.455 7.23005C20 8.29961 20 9.69974 20 12.5V12.5C20 15.3003 20 16.7004 19.455 17.77C18.9757 18.7108 18.2108 19.4757 17.27 19.955C16.2004 20.5 14.8003 20.5 12 20.5V20.5Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88794 9.50299V15.497",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9753 12.502C15.9753 9.50527 14.7691 9.5048 11.7852 9.50478V12.5018V15.4988C14.7841 15.4988 15.9753 15.4987 15.9753 12.502Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgId);
export default __webpack_public_path__ + "static/media/id.23fa30aa2c08dca5269fc60b927e8199.svg";
export { ForwardRef as ReactComponent };